module.exports = __webpack_public_path__ + "static/8-215353a89014bf18df608496d7fa33da.jpg";